import { css } from 'lit';

export default css`
    .install {
        display: flex;
        padding: 3% 5%;
        background-color: var(--color-surface-primary);
        justify-content: space-between;
        align-items: center;
        width: 90%;
        font-weight: 550;
        font-size: var(--font-size-body-m);
        border-bottom: 1px solid var(--color-border-divider-light);
    }

    .install__meta {
        display: flex;
        align-items: center;
        gap: var(--metrics-spacing-s);
    }

    .install__meta > img {
        width: 30px;
        height: 30px;
        background-color: var(--color-surface-primary);
        border-radius: var(--metrics-radius-s);
        padding: 5px;
    }

    .install__functions {
        display: flex;
        gap: var(--metrics-spacing-s);
        align-items: center;
    }

    .secondary__headline {
        color: var(--color-text-secondary);
        font-weight: 400;
        font-size: var(--font-size-body-s);
    }

    .install__functions > div {
        border-radius: 20px;
        color: var(--color-text-invert);
        background-color: var(--color-surface-contrast);
        font-size: var(--font-size-body-xs);
        padding: 9px;
        cursor: pointer;
    }

    .dialogblur {
        position: fixed;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 20;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .iosdialog {
        position: fixed;
        bottom: 10px;
        width: 94%;
        border-radius: 20px;
        background-color: var(--color-surface-accent);
        margin-left: 3%;
    }

    .iosdialog__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 5px;
        padding: 5%;
        border-bottom: solid 1px var(--color-border-divider-light);
    }

    .header__left {
        display: flex;
        align-items: center;
        gap: var(--metrics-spacing-s);
    }

    .header__left > img {
        width: 35px;
        height: 35px;
        background-color: var(--color-surface-primary);
        border-radius: var(--metrics-radius-s);
        padding: 5px;
    }

    .iosdialog__body {
        padding: 5%;
        color: var(--color-text-secondary);
        font-weight: 500;
        font-size: var(--font-size-body-m);
    }

    .iosdialog__body > ol > li {
        margin-bottom: 15px;
        margin-left: 0px;
    }

    .iosdialog__body > ol {
        margin-left: 0px;
        padding: 5%;
    }

    .iosdialog__markedtext {
        background-color: var(--color-surface-primary);
        color: var(--color-text-primary);
        padding: 5px;
        margin-left: 2px;
        border-radius: var(--metrics-radius-s);
    }
`;
